import React, {ChangeEvent} from 'react';
import {Tab, Tabs} from '@material-ui/core';
import {ReactComponent as ErrorIcon} from '../icons/icon-error-status.svg'
import styles from './NxTabs.scss';

export interface NxTab {
  label: React.ReactNode;
  disabled?: boolean;
  error?: boolean;
  tabPanel: React.ReactNode;
  key: string;
}

export interface NxTabsProps {
  tabs: NxTab[];
}

const NxTabs = ({tabs}: NxTabsProps): React.ReactElement => {
  const [value, setValue] = React.useState(tabs[0].key);

  const handleChange = (event: ChangeEvent<unknown>, newValue: string): void => {
    setValue(newValue);
  };

  const tabsClasses = {
    root: styles.tabs,
    indicator: styles.indicator
  };

  const tabClasses = {
    root: styles.tab,
    selected: styles.tab_selected
  };

  const tabIndicatorProps = {
    children: <span className={styles.indicatorThumb} />
  };

  return (
    <>
      <Tabs value={value ?? tabs[0].key}
            onChange={handleChange}
            classes={tabsClasses}
            TabIndicatorProps={tabIndicatorProps}
            aria-label='tabs'>
        {
          tabs.map(tab => {
            const {label, key, error} = tab;

            const labelComponent = (
              <div className={styles.label}>
                <div className={styles.iconWrapper}>{error && <ErrorIcon />}</div>{label}
              </div>
            );

            return <Tab label={labelComponent} classes={tabClasses} value={key} key={key} {...getA11yProps(key) }/>;
          })
        }
      </Tabs>
      {
        tabs.map(tab => (
          <div className={styles.tabPanel}
               hidden={value !== tab.key}
               key={tab.key}
               role='tabpanel'
               {...getA11yProps(tab.key, false) }>
            {value === tab.key && tab.tabPanel}
          </div>
        ))
      }
    </>
  );
}

export default NxTabs;

interface A11yPropsType {
  id: string;
  'aria-controls'?: string;
  'aria-labelledby'?: string;
}

const getA11yProps = (key: string, isForTab= true): A11yPropsType  => {
  const tabId = `tab-${key}`;
  const tabPanelId = `tabpanel-${key}`;
  return isForTab ? {
    id: tabId,
    'aria-controls': tabPanelId
  } : {
    id: tabPanelId,
    'aria-labelledby': tabId
  };
};
